import script from "./VTextDiff.vue?vue&type=script&setup=true&lang=ts"
export * from "./VTextDiff.vue?vue&type=script&setup=true&lang=ts"

import "./VTextDiff.vue?vue&type=style&index=0&id=14925298&lang=scss"

const __exports__ = script;

export default __exports__